// extracted by mini-css-extract-plugin
export var active = "_98-7";
export var container = "_98-0";
export var evenWidth = "_98-4";
export var large = "_98-5";
export var outlet = "_98-8";
export var slide = "_98-2";
export var small = "_98-6";
export var tab = "_98-3";
export var tabs = "_98-1";